import React from 'react';
import { Switch } from '@headlessui/react';
import clx from 'classnames';

import CheckboxIcon from '../../../../../../_ui/_blocks/Form/Inputs/Checkbox/CheckboxIcon/CheckboxIcon';

import styles from './FilterRadioOption.module.css';

export interface Props {
    checked: boolean;
    onChange: () => void;
    disabled?: boolean;
    children: React.ReactNode;
}

const FilterRadioOption = ({ checked, onChange, children, disabled = false }: Props) => {
    const classNames = clx(styles.option, {
        'opacity-50': disabled,
    });

    return (
        <Switch onChange={onChange} className={classNames} checked={checked}>
            {children}
            <CheckboxIcon className="flex-shrink-0" checked={checked} />
        </Switch>
    );
};

export default FilterRadioOption;
